import { render, staticRenderFns } from "./PreCustomer.vue?vue&type=template&id=4d7bf54b"
import script from "./PreCustomer.vue?vue&type=script&lang=js"
export * from "./PreCustomer.vue?vue&type=script&lang=js"
import style0 from "./PreCustomer.vue?vue&type=style&index=0&id=4d7bf54b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports